<!-- Card with hover + tap behaviour ([bare]: the projected body is the trigger itself, e.g. a list row) -->
<div [class]="(bare ? 'dash-popup-trigger ' : 'card h-100 ') + cardClass"
     style="position:relative;cursor:pointer;touch-action:manipulation;"
     (mouseenter)="showHover()"
     (mouseleave)="hideHover()"
     (click)="toggleTap($event)"
     [attr.role]="bare ? 'button' : null"
     [attr.tabindex]="bare ? 0 : null"
     (keydown.enter)="onKey($event)"
     (keydown.space)="onKey($event)">

  <ng-container *ngTemplateOutlet="bodyTpl"></ng-container>

  <!-- Desktop hover popover — has its own mouseenter/mouseleave so the
       6 px gap between card top and popover bottom doesn't close it -->
  <div *ngIf="hovered && !tapped && popupTpl"
       class="d-none d-sm-block"
       style="position:absolute;bottom:calc(100% + 6px);left:50%;
              transform:translateX(-50%);min-width:180px;z-index:200;"
       (mouseenter)="showHover()"
       (mouseleave)="hideHover()">
    <div class="card shadow-lg border p-2">
      <ng-container *ngTemplateOutlet="popupTpl"></ng-container>
    </div>
  </div>

</div>

<!-- Tap overlay: a centred card from 576 px, a full-screen sheet on phones (styles.css: dash-overlay /
     dash-sheet) with a header row of its own (title, 🔗, ✕) and the content scrolling below it -->
<div *ngIf="tapped && (tapTpl || popupTpl)"
     class="dash-overlay dash-overlay-pad" style="background:rgba(0,0,0,0.45);"
     (click)="closeTap()">
  <div class="card shadow-lg border dash-sheet"
       [style.width]="'100%'"
       [style.max-width]="popupMaxWidth"
       style="max-height:calc(100vh - 48px);"
       role="dialog" aria-modal="true" [attr.aria-label]="popupTitle"
       (click)="$event.stopPropagation()">
    <div class="dash-sheet-head dash-sheet-head-plain">
      <div class="dash-sheet-title">{{ popupTitle }}</div>
      <!-- 📌 (admin session only): the chart into / out of the active Analyse slot -->
      <button *ngIf="board.admin && boardChart as bc" type="button" class="btn btn-sm"
              [ngClass]="board.has(bc) ? 'btn-primary' : 'btn-outline-secondary'"
              [attr.aria-pressed]="board.has(bc)" [disabled]="!board.pinReady"
              [title]="board.pinKey(bc) | translate: { title: board.activeTitle }"
              [attr.aria-label]="board.pinKey(bc) | translate: { title: board.activeTitle }"
              (click)="board.toggle(bc)">📌</button>
      <app-link-button *ngIf="linkId"></app-link-button>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="closeTap()"
              [attr.aria-label]="'CLOSE' | translate">✕</button>
    </div>
    <div class="dash-sheet-body">
      <ng-container *ngTemplateOutlet="tapTpl ?? popupTpl ?? null"></ng-container>
    </div>
  </div>
</div>
